import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/coin-red.svg'
import _imports_1 from '@/app/ui/assets/svg/cash.svg'
import _imports_2 from '@/app/ui/assets/svg/topup-white-admin.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-cfad52a4")

_pushScopeId("data-v-cfad52a4")
const _hoisted_1 = { class: "balance-list bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full font-montserrat" }
const _hoisted_2 = { class: "space-y-1" }
const _hoisted_3 = { class: "text-20px" }
const _hoisted_4 = { class: "text-16px" }
const _hoisted_5 = { class: "flex flex-col lg:flex-row py-6 align-middle lg:items-center justify-between w-full gap-y-2" }
const _hoisted_6 = { class: "font-semibold text-20px text-black-lp-200 title-layout flex flex-row flex-wrap align-middle gap-y-2" }
const _hoisted_7 = { class: "flex flex-row flex-no-wrap whitespace-nowrap relative" }
const _hoisted_8 = { class: "w-full px-1 pt-8 flex flex-col gap-y-8 mb-8 border-t border-gray-lp-200" }
const _hoisted_9 = { class: "flex gap-y-2 px-4 py-3 shadow-balance border border-gray-lp-900 rounded-lg" }
const _hoisted_10 = { class: "flex flex-col gap-x-3 px-1" }
const _hoisted_11 = { class: "font-montserrat font-normal text-12px xxl:text-14px text-gray-lp-600 mb-2" }
const _hoisted_12 = { class: "flex flex-row items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-11 max-w-none",
  alt: "coin-red"
}, null, -1)
const _hoisted_14 = { class: "ml-1" }
const _hoisted_15 = { class: "relative flex flex-row items-center rounded-full text-12px xxl:text-14px ml-1" }
const _hoisted_16 = {
  key: 0,
  class: "flex flex-col gap-x-3 px-2"
}
const _hoisted_17 = { class: "font-montserrat font-normal text-12px xxl:text-14px text-gray-lp-600" }
const _hoisted_18 = { class: "flex flex-row items-center" }
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-12 max-w-none",
  alt: "coin-red"
}, null, -1)
const _hoisted_20 = { class: "text-red-lp-500 ml-1" }
const _hoisted_21 = { class: "relative flex flex-row rounded-full text-12px xxl:text-14px ml-1" }
const _hoisted_22 = {
  key: 1,
  class: "flex flex-col gap-x-3 px-2"
}
const _hoisted_23 = { class: "font-montserrat font-normal text-12px xxl:text-14px text-gray-lp-600 mb-2" }
const _hoisted_24 = { class: "flex flex-row items-center" }
const _hoisted_25 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_26 = { class: "relative flex flex-row rounded-full text-12px xxl:text-14px ml-1" }
const _hoisted_27 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_28 = { class: "flex flex-row gap-x-3 justify-end mt-4" }
const _hoisted_29 = {
  key: 0,
  class: "bg-blue-lp-100 border p-4 rounded flex flex-row"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-6 max-w-none",
  alt: "coin-red"
}, null, -1)
const _hoisted_31 = { class: "text-12px text-white mt-1 ml-2 font-normal" }
const _hoisted_32 = {
  key: 2,
  class: "overflow-auto"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Search = _resolveComponent("Search")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_modal_topup = _resolveComponent("modal-topup")!
  const _component_modal_form_topup_manual = _resolveComponent("modal-form-topup-manual")!
  const _component_modal_list_topup_history = _resolveComponent("modal-list-topup-history")!
  const _component_modal_detail_topup_manual = _resolveComponent("modal-detail-topup-manual")!
  const _component_modal_withdraw = _resolveComponent("modal-withdraw")!
  const _component_ModalDownloadMutation = _resolveComponent("ModalDownloadMutation")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_DownloadRequest = _resolveComponent("DownloadRequest")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.isBalancePenaltyNotification)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: 
        `${_ctx.balanceNotification.npStyles} border rounded-lg px-6 py-4 flex flex-row space-x-2 mt-8`
      
          }, [
            _createVNode(_component_Icons, {
              name: "balance-notification",
              class: "h-20"
            }),
            _createVNode("div", _hoisted_2, [
              _withDirectives(_createVNode("div", _hoisted_3, null, 512), [
                [_directive_sanitize_html, _ctx.balanceNotification.npTitle]
              ]),
              _withDirectives(_createVNode("div", _hoisted_4, null, 512), [
                [_directive_sanitize_html, _ctx.balanceNotification.npMessageSecond]
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Search, {
            onInput: _ctx.onSearch,
            onClear: _ctx.clearSearch,
            value: _ctx.search,
            placeholder: _ctx.$t('balance.searchPlaceholderGenesis'),
            class: "flex flex-row items-center w-auto md:w-3/12"
          }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
          _createVNode(_component_CustomDropdown, {
            isExpand: _ctx.isOpenSelect,
            "onUpdate:isExpand": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenSelect = $event)),
            options: _ctx.options,
            onSelect: _ctx.onSelect,
            placeholder: _ctx.$t('balance.filterPlaceholder'),
            class: `select-status ${_ctx.isOpenSelect ? 'w-56' : ''}`,
            isCustomWidth: "",
            isCustomMaxHeight: "",
            selectedItem: _ctx.valueSelect
          }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "class", "selectedItem"]),
          _createVNode(_component_time_range_picker, {
            default: _ctx.$t('7 hari terakhir'),
            class: "mr-4",
            startDate: _ctx.startDate,
            endDate: _ctx.endDate,
            onSelect: _ctx.setDateRange,
            minDate: _ctx.minDate,
            maxDate: _ctx.maxDate,
            onDayClick: _ctx.setDay,
            onCancelRangePick: _ctx.cancelRangePick,
            showOptions: _ctx.timeRangeShowOptions,
            isOptionDisabled: !_ctx.isStartDate
          }, null, 8, ["default", "startDate", "endDate", "onSelect", "minDate", "maxDate", "onDayClick", "onCancelRangePick", "showOptions", "isOptionDisabled"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_lp_button, {
            title: _ctx.$t('balance.downloadButtontitle'),
            textColor: "black-lp-300",
            onClick: _ctx.onModalDownload,
            disabled: false,
            color: "gray-lp-600",
            icon: "download-gray",
            outline: ""
          }, null, 8, ["title", "onClick"])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", {
            class: ["w-full grid grid-cols-1 lg:grid-cols-3 divide-x text-14px xxl:text-20px font-semibold font-montserrat", 
            _ctx.balanceData.walletBalance > _ctx.dataProfile.limit_rule_min_balance
              ? 'text-black-lp-300'
              : 'text-red-lp-500'
          ]
          }, [
            _createVNode("div", _hoisted_10, [
              _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("balance.balanceAvailable")), 1),
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("p", _hoisted_14, _toDisplayString(_ctx.balance), 1),
                _createVNode("div", _hoisted_15, [
                  _createVNode("img", {
                    src: 
                    _ctx.isopenTooltipBalanceAvailable
                      ? require('@/app/ui/assets/svg/information-circle-red.svg')
                      : require('@/app/ui/assets/svg/information-circle.svg')
                  ,
                    class: "w-5 cursor-pointer",
                    onMouseenter: _cache[2] || (_cache[2] = () => _ctx.openTooltipBalanceAvailable(true)),
                    onMouseleave: _cache[3] || (_cache[3] = () => _ctx.openTooltipBalanceAvailable(false)),
                    alt: "warning"
                  }, null, 40, ["src"]),
                  (_ctx.isopenTooltipBalanceAvailable)
                    ? (_openBlock(), _createBlock(_component_Tooltip, {
                        key: 0,
                        title: _ctx.$t('balance.tooltipBalanceAvailableTitle'),
                        message: _ctx.$t('balance.tooltipBalanceAvailableMessage'),
                        style: {"width":"300px","left":"110%","top":"-75%"},
                        onMouseenter: _cache[4] || (_cache[4] = () => _ctx.openTooltipBalanceAvailable(true)),
                        onMouseleave: _cache[5] || (_cache[5] = () => _ctx.openTooltipBalanceAvailable(false))
                      }, null, 8, ["title", "message"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.dataProfile.account_type_detail !== null)
                  ? _withDirectives((_openBlock(), _createBlock("div", {
                      key: 0,
                      class: ["relative flex flex-row rounded-full px-2 text-12px xxl:text-14px ml-3", 
                  `${
                    _ctx.balanceWarning
                      ? 'bg-yellow-lp-200 text-yellow-lp-100'
                      : 'bg-red-lp-600 text-red-lp-500'
                  }`
                ]
                    }, [
                      _createVNode("p", null, _toDisplayString(_ctx.balanceWarningMessage), 1),
                      _createVNode("img", {
                        src: 
                    _ctx.balanceWarning
                      ? require('@/app/ui/assets/svg/exclamation-circle-solid-yellow.svg')
                      : require('@/app/ui/assets/svg/exclamation-circle-solid.svg')
                  ,
                        class: "w-4 ml-2 cursor-pointer",
                        onMouseenter: _cache[6] || (_cache[6] = () => _ctx.openTooltip(true)),
                        onMouseleave: _cache[7] || (_cache[7] = () => _ctx.openTooltip(false)),
                        alt: "warning"
                      }, null, 40, ["src"]),
                      (
                    _ctx.isOpenTooltip && _ctx.dataProfile.account_type_detail !== null
                  )
                        ? (_openBlock(), _createBlock(_component_Tooltip, {
                            key: 0,
                            title: _ctx.balanceWarningMessage,
                            message: _ctx.$t('balance.fillBalanceNow'),
                            style: {"width":"300px","left":"110%","top":"-75%"},
                            onMouseenter: _cache[8] || (_cache[8] = () => _ctx.openTooltip(true)),
                            onMouseleave: _cache[9] || (_cache[9] = () => _ctx.openTooltip(false))
                          }, null, 8, ["title", "message"]))
                        : _createCommentVNode("", true)
                    ], 2)), [
                      [_vShow, _ctx.showBalanceWarning]
                    ])
                  : _createCommentVNode("", true)
              ])
            ]),
            (!_ctx.accountIsForeign)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("balance.balanceDeposit")), 1),
                  _createVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode("p", _hoisted_20, _toDisplayString(_ctx.balanceDeposit), 1),
                    _createVNode("div", _hoisted_21, [
                      _createVNode("img", {
                        src: 
                    _ctx.isopenTooltipBalanceDeposit
                      ? require('@/app/ui/assets/svg/information-circle-red.svg')
                      : require('@/app/ui/assets/svg/information-circle.svg')
                  ,
                        class: "w-5 cursor-pointer",
                        onMouseenter: _cache[10] || (_cache[10] = () => _ctx.openTooltipBalanceDeposit(true)),
                        onMouseleave: _cache[11] || (_cache[11] = () => _ctx.openTooltipBalanceDeposit(false)),
                        alt: "warning"
                      }, null, 40, ["src"]),
                      (_ctx.isopenTooltipBalanceDeposit)
                        ? (_openBlock(), _createBlock(_component_Tooltip, {
                            key: 0,
                            title: _ctx.$t('balance.tooltipBalanceDepositTitle'),
                            message: _ctx.$t('balance.tooltipBalanceDepositMessage'),
                            style: {"width":"300px","left":"110%","top":"-75%"},
                            onMouseenter: _cache[12] || (_cache[12] = () => _ctx.openTooltipBalanceDeposit(true)),
                            onMouseleave: _cache[13] || (_cache[13] = () => _ctx.openTooltipBalanceDeposit(false))
                          }, null, 8, ["title", "message"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.accountIsForeign)
              ? (_openBlock(), _createBlock("div", _hoisted_22, [
                  _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("balance.tierLevel")), 1),
                  _createVNode("div", _hoisted_24, [
                    (_ctx.level?.title)
                      ? (_openBlock(), _createBlock("div", _hoisted_25, [
                          _createVNode("img", {
                            src: require(`@/app/ui/assets/svg/level/${_ctx.level?.icon}.svg`),
                            alt: "level"
                          }, null, 8, ["src"]),
                          _createVNode("div", {
                            class: `pl-2 text-24px font-bold text-${_ctx.level?.color}`
                          }, _toDisplayString(_ctx.level?.title), 3),
                          _createVNode("div", _hoisted_26, [
                            _createVNode("img", {
                              src: 
                      _ctx.isopenTooltipLevel
                        ? require('@/app/ui/assets/svg/information-circle-red.svg')
                        : require('@/app/ui/assets/svg/information-circle.svg')
                    ,
                              class: "w-5 cursor-pointer",
                              onMouseenter: _cache[14] || (_cache[14] = () => _ctx.openTooltipLevel(true)),
                              onMouseleave: _cache[15] || (_cache[15] = () => _ctx.openTooltipLevel(false)),
                              alt: "warning"
                            }, null, 40, ["src"]),
                            (_ctx.isopenTooltipLevel)
                              ? (_openBlock(), _createBlock(_component_Tooltip, {
                                  key: 0,
                                  title: _ctx.$t('balance.tooltipTierLevel'),
                                  message: _ctx.levelTooltip,
                                  style: {"width":"300px","left":"110%","top":"-75%"},
                                  onMouseenter: _cache[16] || (_cache[16] = () => _ctx.openTooltipLevel(true)),
                                  onMouseleave: _cache[17] || (_cache[17] = () => _ctx.openTooltipLevel(false))
                                }, null, 8, ["title", "message"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_27, "-"))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode("div", _hoisted_28, [
            (_ctx.accountIsForeign)
              ? (_openBlock(), _createBlock("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("balance.topupViaAdmin")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isEnableTopUp)
              ? (_openBlock(), _createBlock(_component_lp_button, {
                  key: 1,
                  disabled: false,
                  title: "Topup",
                  textColor: "white",
                  iconLeft: "topup-white",
                  onClick: _ctx.openModalTopup
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isWithdrawDetail)
              ? (_openBlock(), _createBlock(_component_lp_button, {
                  key: 2,
                  title: "",
                  textColor: "white",
                  color: _ctx.isDisableWithdraw ? 'gray-lp-600' : 'red-lp-100',
                  iconLeft: _ctx.isDisableWithdraw ? 'withdraw-gray' : 'withdraw-red',
                  disabled: _ctx.isDisableWithdraw,
                  onClick: _ctx.openModalWithdraw,
                  outline: ""
                }, null, 8, ["color", "iconLeft", "disabled", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (
        !_ctx.startDate &&
          !_ctx.endDate &&
          !_ctx.isLoading &&
          !_ctx.valueSelect.value &&
          !_ctx.search &&
          !_ctx.transactionList.length
      )
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 1,
            customMessage: _ctx.$t('balance.emptyMessage')
          }, null, 8, ["customMessage"]))
        : (_openBlock(), _createBlock("div", _hoisted_32, [
            _createVNode(_component_TableV2, {
              columns: _ctx.columns,
              data: _ctx.transactionList,
              loading: _ctx.isLoading,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[18] || (_cache[18] = ($event: any) => (_ctx.pagination = $event)),
              totalColumnFreeze: 0,
              isRightFreeze: true,
              pinnedSubstractHeight: "382px",
              onRequest: _ctx.fetchTransactionList,
              errorCause: _ctx.errorCause,
              onTryAgain: _ctx.fetchTransactionList,
              shadowYStart: "370",
              showRightShadow: "",
              autoHeight: "",
              paginationWidth: "w-full",
              isThereIsBottonWidget: _ctx.isReportDownload
            }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "errorCause", "onTryAgain", "isThereIsBottonWidget"])
          ]))
    ]),
    (_ctx.isOpenModalTopup)
      ? (_openBlock(), _createBlock(_component_modal_topup, {
          key: 0,
          onClose: _ctx.closeModalTopup
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal_form_topup_manual),
    (_ctx.isShowTransactionHistory)
      ? (_openBlock(), _createBlock(_component_modal_list_topup_history, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.isShowTopupManualDetail)
      ? (_openBlock(), _createBlock(_component_modal_detail_topup_manual, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.isOpenModalWithdraw)
      ? (_openBlock(), _createBlock(_component_modal_withdraw, {
          key: 3,
          onClose: _ctx.closeModalWithdraw
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isModalDownloadMutation)
      ? (_openBlock(), _createBlock(_component_ModalDownloadMutation, {
          key: 4,
          modelValue: _ctx.isModalDownloadMutation,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.isModalDownloadMutation = $event)),
          apiVersion: "v2"
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: () => _ctx.setModalSuccess(false),
      title: _ctx.$t('balance.downloadSuccessTitle'),
      message: "",
      image: "image-modal-success",
      textSuccess: "Ok",
      class: "px-8"
    }, null, 8, ["onSubmit", "title"]), [
      [_vShow, _ctx.isModalSuccessDownloadMutation]
    ]),
    _createVNode(_component_DownloadRequest)
  ], 64))
})